/* eslint-disable no-lonely-if */
const initialWebsiteAnalyticsState = {
  isFetching: true,
  isTesting: false,
  sessions: 0,
  queries: 0,
  impressions: 0,
  sessionsPrev: 0,
  queriesPrev: 0,
  impressionsPrev: 0,
  dataStudioReport: null,
  backlinksReport: null,
  backlinksEnabled: false,
  premiumBacklinks: [],
  semrushRankingKeywords: [{ value: 0 }],
  semrushTrafficValue: [{ value: 0 }],
  semrushRankingKeywordsCurrent: 0,
  semrushTrafficValueCurrent: 0,
  semrushRankingKeywordsPrev: 0,
  semrushTrafficValuePrev: 0,
  semrushRankingKeywordsLabels: [],
  semrushTrafficValueLabels: [],
  sessionsLabels: [],
  queriesLabels: [],
  impressionsLabels: [],
  semrushRankingKeywordsValues: [{ data: [] }],
  semrushTrafficValueValues: [{ data: [] }],
  sessionsValues: [{ data: [] }],
  queriesValues: [{ data: [] }],
  impressionsValues: [{ data: [] }],
  conversionsByChannelLabels: [],
  conversionsByChannelSeries: [],
  gaLeadsLabels: [],
  gaLeadsValues: [{ data: [] }],
  gaROILabels: [],
  gaROIValues: [{ data: [] }],
  gaThreeLinesValues: [
    {
      name: 'Budget',
      type: 'column',
      data: [],
    },
    {
      name: 'CPL',
      type: 'column',
      data: [],
    },
    // {
    //   name: 'Leads Count',
    //   type: 'line',
    //   data: []
    // }
  ],
  keywordRankings: {
    currentPage: 0,
    perPage: 15,
    keywords: [],
    totalKeywords: 0,
  },
  googleMyBusinessData: {
    start_date: '',
    end_date: '',
    search_views_map_views_chart: [
      { name: '', data: [] },
      { name: '', data: [] },
    ],
    search_views_card: {
      current_value: 0,
      previous_value: 0,
      change: 0,
    },
    map_views_card: {
      current_value: 0,
      previous_value: 0,
      change: 0,
    },
    direct_searches_discovery_searches_chart: [
      { name: '', data: [] },
      { name: '', data: [] },
    ],
    direct_searches_card: {
      current_value: 0,
      previous_value: 0,
      change: 0,
    },
    discovery_searches_card: {
      current_value: 0,
      previous_value: 0,
      change: 0,
    },
    actions_chart: [
      { name: '', data: [] },
      { name: '', data: [] },
      { name: '', data: [] },
    ],
    locations_table: [],
    locations_total: 0,
    totals: {
      current_values: {
        website_actions: 0,
        phone_call_actions: 0,
      },
      previous_values: {
        website_actions: 0,
        phone_call_actions: 0,
      },
      change: {
        website_actions: 0,
        phone_call_actions: 0,
      },
    },
  },
};

const websiteAnalyticsActions = {
  WEBSITE_ANALYTICS_SET_ALL: 'WEBSITE_ANALYTICS_SET_ALL',
  WEBSITE_ANALYTICS_SET_IS_FETCHING: 'WEBSITE_ANALYTICS_SET_IS_FETCHING',
  WEBSITE_ANALYTICS_CLEAN: 'WEBSITE_ANALYTICS_CLEAN',
  WEBSITE_ANALYTICS_STAR: 'WEBSITE_ANALYTICS_STAR',
  WEBSITE_ANALYTICS_SET_GMB: 'WEBSITE_ANALYTICS_SET_GMB',
};

function websiteAnalyticsReducer(state, action) {
  const newState = state;
  
  switch (action.type) {
    case websiteAnalyticsActions.WEBSITE_ANALYTICS_SET_ALL:
      if (action.payload.goal_completions) {
        newState.conversionsByChannelLabels = [];
        newState.conversionsByChannelSeries = [];
        const conversionsByChannel = {};
        Object.keys(action.payload.goal_completions).forEach((goal) => {
          action.payload.goal_completions[goal].forEach((el) => {
            if (!Object.keys(conversionsByChannel).includes(el.source_type)) {
              conversionsByChannel[el.source_type] = el.completions;
            } else {
              conversionsByChannel[el.source_type] += el.completions;
            }
          });
        });
        newState.conversionsByChannelLabels = Object.keys(conversionsByChannel);
        newState.conversionsByChannelLabels.forEach((el) => {
          newState.conversionsByChannelSeries.push(conversionsByChannel[el]);
        });
      }
      if(typeof action.payload.dataStudioReport !== 'undefined') {
        newState.dataStudioReport = action.payload.dataStudioReport;
      }
      if(typeof action.payload.backlinksReport !== 'undefined') {
        newState.backlinksReport = action.payload.backlinksReport;
        newState.backlinksEnabled = action.payload.backlinksEnabled;
      }
      if (action.payload.semrushAverages) {
        newState.semrushRankingKeywordsLabels = [];
        newState.semrushRankingKeywordsValues[0].data = [];
        newState.semrushTrafficValueLabels = [];
        newState.semrushTrafficValueValues[0].data = [];
        let counter = 0;
        Object.keys(action.payload.semrushAverages).forEach((item) => {
          if (counter === Object.keys(action.payload.semrushAverages).length - 1) {
            if (action.payload.semrushAverages[item].rankingKeywords) {
              newState.semrushRankingKeywordsCurrent = parseInt(
                action.payload.semrushAverages[item].rankingKeywords,
                10
              );
            } else {
              newState.semrushRankingKeywordsCurrent = 0;
            }
            if (action.payload.semrushAverages[item].organicCost) {
              newState.semrushTrafficValueCurrent = parseInt(
                action.payload.semrushAverages[item].organicCost,
                10
              );
            } else {
              newState.semrushTrafficValueCurrent = 0;
            }
          }
          if (counter === Object.keys(action.payload.semrushAverages).length - 2) {
            if (action.payload.semrushAverages[item].rankingKeywords) {
              newState.semrushRankingKeywordsPrev = parseInt(
                action.payload.semrushAverages[item].rankingKeywords,
                10
              );
            } else {
              newState.semrushRankingKeywordsPrev = 0;
            }
            if (action.payload.semrushAverages[item].organicCost) {
              newState.semrushTrafficValuePrev = parseInt(
                action.payload.semrushAverages[item].organicCost,
                10
              );
            } else {
              newState.semrushTrafficValuePrev = 0;
            }
          }
          const date = new Date(`${item}-02`);
          newState.semrushRankingKeywordsLabels.push(
            encodeURIComponent(date.toLocaleString('en-US', { month: 'short' }))
          );
          newState.semrushTrafficValueLabels.push(
            encodeURIComponent(date.toLocaleString('en-US', { month: 'short' }))
          );
          if (action.payload.semrushAverages[item].rankingKeywords) {
            newState.semrushRankingKeywordsValues[0].data.push(
              parseInt(action.payload.semrushAverages[item].rankingKeywords, 10)
                .toFixed(0)
                .toString()
            );
          } else {
            newState.semrushRankingKeywordsValues[0].data.push('0');
          }
          if (action.payload.semrushAverages[item].organicCost) {
            newState.semrushTrafficValueValues[0].data.push(
              parseInt(action.payload.semrushAverages[item].organicCost, 10).toFixed(0).toString()
            );
          } else {
            newState.semrushTrafficValueValues[0].data.push('0');
          }
          counter += 1;
        });
      }
      if (action.payload.history) {
        if (action.payload.history[0] && action.payload.history[0].values.length !== 0) {
          newState.gaROILabels = [];
          newState.gaROIValues[0].data = [];
          newState.gaThreeLinesValues[0].data = [];
          newState.gaThreeLinesValues[1].data = [];
          // newState.gaThreeLinesValues[2].data = [];
          newState.gaLeadsValues[0].data = [];
          newState.gaLeadsLabels = [];
          newState.sessionsValues[0].data = [];
          newState.sessionsLabels = [];
          newState.queriesValues[0].data = [];
          newState.queriesLabels = [];
          newState.impressionsValues[0].data = [];
          newState.impressionsLabels = [];
          let counter = 0;
          action.payload.history.forEach((item) => {
            const date = new Date(`${item.start_date.slice(0, -1)}2`);
            newState.sessionsLabels.push(
              `${encodeURIComponent(
                date.toLocaleString('en-US', { month: 'short' })
              )} ${date.getFullYear()}`
            );
            newState.queriesLabels.push(
              `${encodeURIComponent(
                date.toLocaleString('en-US', { month: 'short' })
              )} ${date.getFullYear()}`
            );
            newState.impressionsLabels.push(
              `${encodeURIComponent(
                date.toLocaleString('en-US', { month: 'short' })
              )} ${date.getFullYear()}`
            );
            newState.sessionsValues[0].data.push(item.values.ga_sessions_organic.toString());
            newState.queriesValues[0].data.push(item.values.gsc_queries.toString());
            newState.impressionsValues[0].data.push(item.values.gsc_impressions.toString());
            if (counter === action.payload.history.length - 2) {
              newState.sessionsPrev = item.values.ga_sessions_organic;
              newState.queriesPrev = item.values.gsc_queries;
              newState.impressionsPrev = item.values.gsc_impressions;
            }
            if (counter === action.payload.history.length - 1) {
              newState.sessions = item.values.ga_sessions_organic;
              newState.queries = item.values.gsc_queries;
              newState.impressions = item.values.gsc_impressions;
            }
            if (counter > action.payload.history.length - 7) {
              newState.gaLeadsLabels.push(date.toLocaleString('en-US', { month: 'short' }));
              newState.gaLeadsValues[0].data.push(
                item.values.ga_goalCompletionsAll_organic.toString()
              );

              let budget = 0;
              if (action.payload.budgetHistory) {
                Object.keys(action.payload.budgetHistory).forEach((budgetMonthYear) => {
                  const dateBudget = new Date(budgetMonthYear);
                  if (
                    `${date.toLocaleString('en-US', { month: 'short' })} ${date.getFullYear()}` ===
                    `${dateBudget.toLocaleString('en-US', {
                      month: 'short',
                    })} ${dateBudget.getFullYear()}`
                  ) {
                    if (action.payload.budgetHistory[budgetMonthYear]) {
                      budget = action.payload.budgetHistory[budgetMonthYear];
                    }
                  }
                });
              }
              newState.gaThreeLinesValues[0].data.push(budget);
              if (item.values.ga_goalCompletionsAll_organic) {
                newState.gaROIValues[0].data.push(
                  (budget / item.values.ga_goalCompletionsAll_organic).toFixed(0).toString()
                );
                newState.gaThreeLinesValues[1].data.push(
                  (budget / item.values.ga_goalCompletionsAll_organic).toFixed(0).toString()
                );
              } else {
                newState.gaROIValues[0].data.push(budget);
                newState.gaThreeLinesValues[1].data.push(budget);
              }
              newState.gaROILabels.push(
                `${date.toLocaleString('en-US', { month: 'short' })}  ($${budget.toString()})`
              );
            }
            // newState.gaThreeLinesValues[2].data = newState.gaLeadsValues[0].data;
            counter += 1;
          });
        } else {
          newState.gaROILabels = [];
          newState.gaROIValues[0].data = [];
          newState.gaThreeLinesValues[0].data = [];
          newState.gaThreeLinesValues[1].data = [];
          // newState.gaThreeLinesValues[2].data = [];
          newState.sessionsValues[0].data = [];
          newState.sessionsLabels = [];
          newState.gaLeadsValues[0].data = [];
          newState.gaLeadsLabels = [];
          newState.queriesValues[0].data = [];
          newState.queriesLabels = [];
          newState.impressionsValues[0].data = [];
          newState.impressionsLabels = [];
        }
      }
      if (action.payload.keywordRankings) {
        return {
          ...newState,
          ...action.payload,
          keywordRankings: { ...newState.keywordRankings, ...action.payload.keywordRankings },
        };
      }
      if(typeof action.payload.premiumBacklinks !== 'undefined') {
        newState.premiumBacklinks = action.payload.premiumBacklinks;
      }
      return { ...newState, ...action.payload };
    case websiteAnalyticsActions.WEBSITE_ANALYTICS_STAR:
      for (let i = 0; i < newState.keywordRankings.keywords.length; i += 1) {
        if (newState.keywordRankings.keywords[i].keyword === action.payload.keyword) {
          newState.keywordRankings.keywords[i].starred = action.payload.starred;
        }
      }
      return { ...newState };
    case websiteAnalyticsActions.WEBSITE_ANALYTICS_SET_IS_FETCHING:
      return { ...state, isFetching: action.payload.isFetching };
    case websiteAnalyticsActions.WEBSITE_ANALYTICS_CLEAN:
      return structuredClone(initialWebsiteAnalyticsState);
    case websiteAnalyticsActions.WEBSITE_ANALYTICS_SET_GMB:
      if (action.payload.googleMyBusiness && action.payload.googleMyBusiness.values) {
        const searchViewsCard = {
          previous_value: action.payload.googleMyBusiness.values.search_views[0].value,
          current_value:
            action.payload.googleMyBusiness.values.search_views[
              action.payload.googleMyBusiness.values.search_views.length - 1
            ].value,
        };
        searchViewsCard.change = (
          ((searchViewsCard.current_value - searchViewsCard.previous_value) /
            searchViewsCard.previous_value) *
          100
        ).toFixed(2);

        const mapViewsCard = {
          previous_value: action.payload.googleMyBusiness.values.map_views[0].value,
          current_value:
            action.payload.googleMyBusiness.values.map_views[
              action.payload.googleMyBusiness.values.map_views.length - 1
            ].value,
        };
        mapViewsCard.change = (
          ((mapViewsCard.current_value - mapViewsCard.previous_value) /
            mapViewsCard.previous_value) *
          100
        ).toFixed(2);

        const directSearchesCard = {
          previous_value: action.payload.googleMyBusiness.values.direct_searches[0].value,
          current_value:
            action.payload.googleMyBusiness.values.direct_searches[
              action.payload.googleMyBusiness.values.direct_searches.length - 1
            ].value,
        };
        directSearchesCard.change = (
          ((directSearchesCard.current_value - directSearchesCard.previous_value) /
            directSearchesCard.previous_value) *
          100
        ).toFixed(2);

        const discoverySearchesCard = {
          previous_value: action.payload.googleMyBusiness.values.discovery_searches[0].value,
          current_value:
            action.payload.googleMyBusiness.values.discovery_searches[
              action.payload.googleMyBusiness.values.discovery_searches.length - 1
            ].value,
        };
        discoverySearchesCard.change = (
          ((discoverySearchesCard.current_value - discoverySearchesCard.previous_value) /
            discoverySearchesCard.previous_value) *
          100
        ).toFixed(2);

        const { locations } = action.payload.googleMyBusiness.values;
        let locationsTable = [];
        if (locations.current_values && Object.keys(locations.current_values)) {
          locationsTable = Object.keys(locations.current_values).map((location, index) => ({
            id: index + 1,
            store_code: location,
            website_actions: locations.current_values[location].website_actions,
            website_actions_change: locations.change[location].website_actions,
            phone_call_actions: locations.current_values[location].phone_call_actions,
            phone_call_actions_change: locations.change[location].phone_call_actions,
            total_views: locations.current_values[location].total_views,
            total_views_change: locations.change[location].total_views,
            total_searches: locations.current_values[location].total_searches,
            total_searches_change: locations.change[location].total_searches,
          }));
        }

        newState.googleMyBusinessData = {
          start_date: action.payload.googleMyBusiness.start_date,
          end_date: action.payload.googleMyBusiness.end_date,
          search_views_map_views_chart: [
            {
              name: 'Search Views',
              data: action.payload.googleMyBusiness.values.search_views.map((data) => ({
                x: new Date(data.date).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                }),
                y: data.value,
              })),
            },
            {
              name: 'Map Views',
              data: action.payload.googleMyBusiness.values.map_views.map((data) => ({
                x: new Date(data.date).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                }),
                y: data.value,
              })),
            },
          ],
          search_views_card: searchViewsCard,
          map_views_card: mapViewsCard,
          direct_searches_discovery_searches_chart: [
            {
              name: 'Direct Searches',
              data: action.payload.googleMyBusiness.values.direct_searches.map((data) => ({
                x: new Date(data.date).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                }),
                y: data.value,
              })),
            },
            {
              name: 'Discovery Searches',
              data: action.payload.googleMyBusiness.values.discovery_searches.map((data) => ({
                x: new Date(data.date).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                }),
                y: data.value,
              })),
            },
          ],
          direct_searches_card: directSearchesCard,
          discovery_searches_card: discoverySearchesCard,
          actions_chart: [
            {
              name: 'Phone call actions',
              data: action.payload.googleMyBusiness.values.phone_call_actions.map((data) => ({
                x: new Date(data.date).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                }),
                y: data.value,
              })),
            },
            {
              name: 'Direction actions',
              data: action.payload.googleMyBusiness.values.direction_actions.map((data) => ({
                x: new Date(data.date).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                }),
                y: data.value,
              })),
            },
            {
              name: 'Website actions',
              data: action.payload.googleMyBusiness.values.website_actions.map((data) => ({
                x: new Date(data.date).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                }),
                y: data.value,
              })),
            },
          ],
          locations_table: locationsTable,
          locations_total: locations.total_count,
          totals: action.payload.googleMyBusiness.values.totals,
        };
      }
      return { ...newState, ...action.payload };
    default:
      return state;
  }
}

export { initialWebsiteAnalyticsState, websiteAnalyticsActions, websiteAnalyticsReducer };
